import styled from 'styled-components/macro';

export namespace Styled {
	export const Root = styled.div``;
}
